"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var http_1 = require("@angular/http");
var _1 = require(".");
var interfaces_1 = require("../interfaces");
var storage_service_1 = require("./storage.service");
var Module = window.Module;
var PackLevelService = (function () {
    function PackLevelService(http, resourcePreloaderService, storageService) {
        this.http = http;
        this.resourcePreloaderService = resourcePreloaderService;
        this.storageService = storageService;
        this.levelIdsByNumbers = {};
        this.gameControl = Module.GMGameControl.create(1, 1, true, false);
        this.GM_OPENED_MAX_LEVEL_ID = "TEquilateral";
        this.GM_COMBO_TUTORIAL_LEVEL_ID = "TEquilateral";
        this.GM_MOVE_TOOL_TUTORIAL_LEVEL_ID = "TMove";
        this.readLevels();
    }
    PackLevelService.prototype.packWithLevelId = function (levelId) {
        for (var _i = 0, _a = this.packIds; _i < _a.length; _i++) {
            var packId = _a[_i];
            var pack = this.packs[packId];
            if (pack != null && pack.levelIds.indexOf(levelId) != -1) {
                return pack;
            }
        }
        return null;
    };
    PackLevelService.prototype.previousPackId = function (packId) {
        var index = this.numberForPackWithId(packId) - 1;
        if (index === 0) {
            return null;
        }
        return this.packIds[index - 1];
    };
    PackLevelService.prototype.numberForPackWithId = function (packId) {
        return this.packIds.indexOf(packId) + 1;
    };
    PackLevelService.prototype.nextLevelId = function (levelId) {
        var pack = this.packWithLevelId(levelId);
        var currentIndex = pack.levelIds.indexOf(levelId);
        if (currentIndex === pack.levelIds.length - 1) {
            var nextPackId = this.nextPackId(pack.packId);
            if (nextPackId == null) {
                return null;
            }
            var nextPack = this.packs[nextPackId];
            return nextPack.levelIds[0];
        }
        return pack.levelIds[currentIndex + 1];
    };
    PackLevelService.prototype.previousLevelId = function (levelId) {
        var pack = this.packWithLevelId(levelId);
        var currentIndex = pack.levelIds.indexOf(levelId);
        if (currentIndex === 0) {
            var prevPackId = this.previousPackId(pack.packId);
            if (prevPackId == null) {
                return null;
            }
            var prevPack = this.packs[prevPackId];
            return prevPack.levelIds[prevPack.levelIds.length - 1];
        }
        return pack.levelIds[currentIndex - 1];
    };
    PackLevelService.prototype.nextPackId = function (packId) {
        var index = this.numberForPackWithId(packId) - 1;
        if (index + 1 > this.packIds.length) {
            return null;
        }
        return this.packIds[index + 1];
    };
    PackLevelService.prototype.countTutorialsBeforeLevelWithId = function (levelId) {
        var pack = this.packWithLevelId(levelId);
        var count = 0;
        for (var i = 0; i < pack.levelIds.length; i++) {
            var curLevelId = pack.levelIds[i];
            if (curLevelId === levelId) {
                return count;
            }
            var level = this.levels[curLevelId];
            if (level.tutorial) {
                count++;
            }
        }
        return -1;
    };
    PackLevelService.prototype.numberOfLevelWithId = function (levelId) {
        var level = this.levels[levelId];
        if (level.tutorial) {
            return 0;
        }
        var pack = this.packWithLevelId(levelId);
        var index = pack.levelIds.indexOf(levelId);
        var tutorialsBeforeCount = this.countTutorialsBeforeLevelWithId(levelId);
        index = index - tutorialsBeforeCount + 1;
        return index;
    };
    PackLevelService.prototype.levelsInPackId = function (packId) {
        var levels = [];
        var levelIds = this.packs[packId].levelIds;
        for (var i = 0; i < levelIds.length; i++) {
            var levelId = levelIds[i];
            levels.push(this.levels[levelId]);
        }
        return levels;
    };
    PackLevelService.prototype.totalStars = function () {
        var totalStars = 0;
        for (var i = 0; i < this.levelIds.length; i++) {
            var level = this.levels[this.levelIds[i]];
            totalStars += 3;
            if (level.hasVStar)
                totalStars += 1;
        }
        return totalStars;
    };
    PackLevelService.prototype.starsCountForPackId = function (packId) {
        var starsCount = 0;
        var pack = this.packs[packId];
        for (var i = 0; i < pack.levelIds.length; i++) {
            var levelId = pack.levelIds[i];
            var level = this.levels[levelId];
            starsCount += 3;
            if (level.hasVStar) {
                starsCount += 1;
            }
        }
        return starsCount;
    };
    PackLevelService.prototype.getPacksData = function () {
        var parser = new DOMParser();
        var xmlData = parser.parseFromString(this.resourcePreloaderService.levels, "application/xml");
        return xmlData;
    };
    PackLevelService.prototype.readLevels = function () {
        var tempPacksObj = {};
        var tempLevelsObj = {};
        var tempPacksIdsArr = [];
        var tempLevelsIdsArr = [];
        var xml = this.getPacksData();
        var packNumber = 0;
        for (var _i = 0, _a = xml.querySelectorAll('pack'); _i < _a.length; _i++) {
            var pack = _a[_i];
            packNumber++;
            var levelIdsInPack = [];
            var levelCounter = 0;
            var packId = pack.getAttribute('id');
            tempPacksObj[packId] = { packId: packId };
            tempPacksIdsArr.push(packId);
            for (var _b = 0, _c = pack.querySelectorAll('level'); _b < _c.length; _b++) {
                var level = _c[_b];
                var allowedTools = level.getAttribute('allowed');
                var levelId = level.getAttribute('id');
                var levelTutorial = level.getAttribute('tutorial');
                var levelLearned = level.getAttribute('learned');
                allowedTools = allowedTools ? allowedTools.split(',') : [];
                var reward = level.querySelector('reward');
                var moves = void 0;
                var lines = void 0;
                var variantsCount = void 0;
                if (!reward) {
                    moves = 0;
                }
                else {
                    variantsCount = Number(reward.getAttribute('variants'));
                    moves = Number(reward.getAttribute('moves'));
                    lines = Number(reward.getAttribute('lines'));
                }
                lines = lines ? lines : moves;
                var levelObj = {
                    levelId: levelId,
                    tutorial: levelTutorial === 'true',
                    allowedToolTypes: allowedTools,
                    unlockedToolType: levelLearned,
                    goalElementaryMoves: moves,
                    goalLineMoves: lines,
                    variantsCount: variantsCount,
                    packNumber: packNumber
                };
                tempLevelsObj[levelId] = new interfaces_1.Level(levelObj);
                if (variantsCount > 1) {
                    tempLevelsObj[levelId].hasVStar = true;
                }
                if (!tempLevelsObj[levelId].tutorial) {
                    levelCounter += 1;
                }
                tempLevelsObj[levelId].levelNumber = levelCounter;
                tempLevelsIdsArr.push(levelId);
                levelIdsInPack.push(levelId);
            }
            tempPacksObj[pack.getAttribute('id')].levelIds = levelIdsInPack;
        }
        for (var _d = 0, tempLevelsIdsArr_1 = tempLevelsIdsArr; _d < tempLevelsIdsArr_1.length; _d++) {
            var idStr = tempLevelsIdsArr_1[_d];
            var float = tempLevelsObj[idStr].packNumber + '.' + tempLevelsObj[idStr].levelNumber;
            var isTutorial = tempLevelsObj[idStr].tutorial;
            !isTutorial ? this.levelIdsByNumbers[float] = idStr : '';
        }
        this.levels = tempLevelsObj;
        this.packs = tempPacksObj;
        this.levelIds = tempLevelsIdsArr;
        this.packIds = tempPacksIdsArr;
    };
    return PackLevelService;
}());
PackLevelService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http,
        _1.ResourcePreloaderService,
        storage_service_1.StorageService])
], PackLevelService);
exports.PackLevelService = PackLevelService;



//////////////////
// WEBPACK FOOTER
// ./src/services/pack-level.service.ts
// module id = 101
// module chunks = 0